import { useState, useEffect } from 'react';

import { Button } from '@livechat/design-system-react-components';
import Cookies from 'js-cookie';

import Config from 'Config';
import { CustomLink } from 'components/link/Link';
import { GTMEvents } from 'constants/tracking';
import { fetchProducts } from 'hooks/use-products';
import GTM from 'modules/GTM';
import Location from 'modules/Location';
import Utils from 'modules/Utils';
import { useSharedStore } from 'stores/shared-store';

export const NewAccount = () => {
  const [skipSelectTrial, setSkipSelectTrial] = useState(false);
  const cookieProduct = Cookies.get('product');

  const checkIfShouldSkipSelectTrial = async () => {
    const clientId = Location.getUrlParam('client_id');
    let isKnownClientId = true;

    if (clientId) {
      try {
        const products = await fetchProducts();

        isKnownClientId =
          products.some((product) => product.client_id === clientId) ||
          clientId === Config.default_client_id ||
          clientId === import.meta.env.VITE_APP_CLIENT_ID;
      } finally {
        if (!isKnownClientId || cookieProduct) {
          setSkipSelectTrial(true);
        }
      }
    }
  };

  useEffect(() => {
    checkIfShouldSkipSelectTrial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreateAccountClick = () => {
    if (!Location.isInLoginButtonPopup()) {
      GTM.track(GTMEvents.GENERIC, {
        eventCategory: GTMEvents.CATEGORIES.INTERACTIONS,
        eventAction: GTMEvents.ACTIONS.SIGN_UP_FREE,
      });

      return;
    }

    const createAccountButtonAction = Location.getUrlParam('create_account_button_action');

    switch (createAccountButtonAction) {
      case 'close-popup':
        Location.closePopupWindow();
        break;
      default:
    }
  };

  const defaultParams = {
    source_id: 'create_account_link',
    source_url: window.location.origin,
    source_type: 'accounts',
  };

  const sharedStore = useSharedStore();
  sharedStore.addMissing(defaultParams);
  const sharedStoreParams = sharedStore.toObject();
  const queryString = Object.keys(sharedStoreParams)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(sharedStoreParams[key].toString())}`
    )
    .join('&');

  if (Utils.shouldHideSignUp()) {
    return null;
  }

  return (
    <CustomLink
      to={skipSelectTrial ? '/signup' : '/select-trial'}
      onClick={handleCreateAccountClick}
      qs={queryString}
      dataTestId="new-account-cutom-link"
    >
      <Button kind="secondary" size="medium" data-testid="new-account-button">
        Sign up free
      </Button>
    </CustomLink>
  );
};
